import { countryUpdateApi } from "../../api/country/countryUpdateApi"

type PayloadShape = Parameters<typeof countryUpdateApi>[0]

export async function countryUpdateService(payload: PayloadShape, token: string) {
	return await countryUpdateApi(payload, token)
}
